// @ts-nocheck

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import * as S from './styles';

// Components
import SearchIcon from 'images/icons/search.svg';

// Analytics
import { useInView } from 'react-intersection-observer';

// Misc / Util
import { adapt_reduxToQuery } from 'app/shared/flux/actions/FilterActions/adapters';
import queryUtils from 'app/shared/utils/queryUtils';

const NearbyAreas = ({ areaName, nearbyAreas, isLoading }) => {
  const NEARBY_AREA_COUNT = 6;
  const filter = useSelector((state) => state.filter);
  const sortedNearbyAreas = useMemo(() => nearbyAreas.sort((a, b) => b.name.length - a.name.length), [nearbyAreas]);
  const dispatch = useDispatch();

  const getAreaUrl = useCallback(
    (areaResourceId) => {
      const path = `/${areaResourceId}/${filter.search.slug}`;
      const queryObj = adapt_reduxToQuery({ filter });
      const url = path + queryUtils.stringify(queryObj);

      return url;
    },
    [filter],
  );

  const renderButtonSkeletons = useCallback(() => {
    const skeletons = [];

    for (let i = 0; i < NEARBY_AREA_COUNT; i++) {
      skeletons.push(<S.ButtonSkeleton key={i} />);
    }

    return skeletons;
  }, []);

  const [trackingRef] = useInView({
    triggerOnce: true,
  });

  return (
    <S.Container>
      {isLoading && (
        <>
          <S.HeaderTextSkeleton />
          <S.NearbyAreas>{renderButtonSkeletons()}</S.NearbyAreas>
        </>
      )}

      {!isLoading && (
        <>
          <S.HeaderText aria-label={`This collection contains other areas near ${areaName} to search for rentals in`}>
            Other Areas Near {areaName}
          </S.HeaderText>
          <S.NearbyAreas>
            {sortedNearbyAreas.map((area) => {
              const link = getAreaUrl(area.resourceId);

              return (
                <S.NearbyAreaButton
                  key={area.resourceId}
                  hasLongNameMobile={area.name.length > 14}
                  href={link}
                  aria-label={`View rentals in ${area.name}`}
                >
                  <S.SearchIcon src={SearchIcon} atl="" />
                  <S.NearbyAreaName>{area.name}</S.NearbyAreaName>
                </S.NearbyAreaButton>
              );
            })}
          </S.NearbyAreas>
        </>
      )}

      <span ref={trackingRef} />
    </S.Container>
  );
};

const { string, array, bool } = PropTypes;

NearbyAreas.propTypes = {
  areaName: string.isRequired,
  nearbyAreas: array.isRequired,
  isLoading: bool.isRequired,
};

export default NearbyAreas;
